module.exports = __webpack_public_path__ + "static/media/ks_shack_background_tablet.e0d2bbe9.jpg";